var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNumberCircle3 = function SvgNumberCircle3(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    stroke: "var(--color-primary)",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 8,
    fill: "none",
    stroke: "inherit",
    strokeWidth: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    stroke: "none",
    d: "M20 17.8a3 3 0 0 0-1.7-2.8 3 3 0 0 0 1.2-2.5c0-1.9-1.5-3-3.5-3-1.8 0-3.1.8-4 2l1.8 1.2c.5-.8 1.1-1.3 2-1.3s1.5.5 1.5 1.3c0 .9-.7 1.4-1.6 1.4H14v2h1.8c1.2 0 2 .6 2 1.6s-.8 1.7-1.9 1.7c-1 0-1.8-.5-2.5-1.8l-1.8 1.2c.9 1.6 2.2 2.5 4.3 2.5 2.4 0 4.1-1.4 4.1-3.5"
  })));
};
export default SvgNumberCircle3;